import { useState } from "react";
import { Calendar, Mail, MapPin, Send } from "lucide-react";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [sent, setSent] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setSent(true);
  };

  return (
    <section id="contact" className="border-t px-4 py-16 sm:px-6 sm:py-20 lg:py-28" style={{ background: "var(--background)", borderColor: "var(--border)" }}>
      <div className="mx-auto max-w-6xl">
        <div className="mb-8 sm:mb-12 section-label">// 05 &nbsp; CONTACT</div>
        <div className="grid gap-10 md:grid-cols-2 lg:gap-16">
          <div>
            <h2 className="mb-4 section-heading">Let's work<br /><span style={{ color: "var(--primary)" }}>together</span></h2>
            <p className="mb-8 body-copy sm:mb-10">Open to QA automation roles, software development work, product collaborations, and consulting on test strategy.</p>
            <div className="flex flex-col gap-5">
              {[
                { icon: MapPin, label: "Location", value: "Accra, Ghana" },
                { icon: Mail, label: "Email", value: "musib581@gmail.com" },
                { icon: Calendar, label: "Availability", value: "Open to projects and opportunities" },
              ].map(({ icon: Icon, label, value }) => (
                <div key={label} className="flex items-start gap-4">
                  <div className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded border" style={{ borderColor: "var(--border)", background: "var(--card)" }}>
                    <Icon size={13} style={{ color: "var(--primary)" }} />
                  </div>
                  <div>
                    <div className="mono-small" style={{ textTransform: "uppercase", marginBottom: "0.125rem" }}>{label}</div>
                    <div className="card-title" style={{ fontSize: "0.875rem" }}>{value}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="rounded border p-5 sm:p-8 card-surface">
            {sent ? (
              <div className="flex h-full flex-col items-center justify-center gap-4 py-12">
                <div className="flex h-12 w-12 items-center justify-center rounded-full border" style={{ borderColor: "var(--accent)", color: "var(--accent)" }}><Send size={20} /></div>
                <div className="section-heading" style={{ fontSize: "1.25rem", textAlign: "center" }}>Message sent</div>
                <p className="body-small text-center">Thanks for reaching out. You can also email me directly at musib581@gmail.com.</p>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="flex flex-col gap-5">
                {[
                  { id: "name", label: "Name", type: "text", placeholder: "Your name" },
                  { id: "email", label: "Email", type: "email", placeholder: "you@company.com" },
                ].map(({ id, label, type, placeholder }) => (
                  <div key={id}>
                    <label htmlFor={id} className="mb-2 block mono-small" style={{ textTransform: "uppercase" }}>{label}</label>
                    <input id={id} type={type} required placeholder={placeholder} value={form[id]} onChange={(e) => setForm({ ...form, [id]: e.target.value })} className="w-full rounded border px-4 py-3 outline-none transition-all duration-200" style={{ background: "var(--secondary)", borderColor: "var(--border)", color: "var(--foreground)", fontFamily: "var(--font-sans)", fontSize: "0.875rem" }} />
                  </div>
                ))}
                <div>
                  <label htmlFor="message" className="mb-2 block mono-small" style={{ textTransform: "uppercase" }}>Message</label>
                  <textarea id="message" required rows={5} placeholder="Tell me about the role or project..." value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} className="w-full resize-none rounded border px-4 py-3 outline-none transition-all duration-200" style={{ background: "var(--secondary)", borderColor: "var(--border)", color: "var(--foreground)", fontFamily: "var(--font-sans)", fontSize: "0.875rem" }} />
                </div>
                <button type="submit" className="flex items-center justify-center gap-2 rounded px-6 py-3 transition-all duration-200 hover:opacity-90" style={{ background: "var(--primary)", color: "var(--primary-foreground)", fontFamily: "var(--font-sans)", fontSize: "0.875rem", fontWeight: 500 }}>
                  <Send size={14} /> Send Message
                </button>
              </form>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
